/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ContactDetailType } from './ContactDetailType';
import {
    ContactDetailTypeFromJSON,
    ContactDetailTypeFromJSONTyped,
    ContactDetailTypeToJSON,
    ContactDetailTypeToJSONTyped,
} from './ContactDetailType';

/**
 * 
 * @export
 * @interface ContactDetailResponse
 */
export interface ContactDetailResponse {
    /**
     * 
     * @type {string}
     * @memberof ContactDetailResponse
     */
    id: string;
    /**
     * 
     * @type {ContactDetailType}
     * @memberof ContactDetailResponse
     */
    type: ContactDetailType;
    /**
     * 
     * @type {string}
     * @memberof ContactDetailResponse
     */
    value: string;
    /**
     * 
     * @type {string}
     * @memberof ContactDetailResponse
     */
    comment: string | null;
}



/**
 * Check if a given object implements the ContactDetailResponse interface.
 */
export function instanceOfContactDetailResponse(value: object): value is ContactDetailResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('comment' in value) || value['comment'] === undefined) return false;
    return true;
}

export function ContactDetailResponseFromJSON(json: any): ContactDetailResponse {
    return ContactDetailResponseFromJSONTyped(json, false);
}

export function ContactDetailResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactDetailResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': ContactDetailTypeFromJSON(json['type']),
        'value': json['value'],
        'comment': json['comment'],
    };
}

export function ContactDetailResponseToJSON(json: any): ContactDetailResponse {
    return ContactDetailResponseToJSONTyped(json, false);
}

export function ContactDetailResponseToJSONTyped(value?: ContactDetailResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': ContactDetailTypeToJSON(value['type']),
        'value': value['value'],
        'comment': value['comment'],
    };
}

